import { UserRoleType } from '../heyapi/types.gen';
import { usePermissionsStore } from './usePermissionsStore';

// Role hierarchy: higher number = more permissions
const ROLE_HIERARCHY: Record<UserRoleType, number> = {
  [UserRoleType.AGENT]: 1,
  [UserRoleType.UNDERWRITER]: 2,
  [UserRoleType.UNDERWRITING_ADMIN]: 3,
  [UserRoleType.SYSTEM_ADMIN]: 4,
};

/**
 * Reactive hook for role-based permissions.
 * Use this instead of accessing role helpers directly from the store.
 */
export const useRole = () => {
  const role = usePermissionsStore((state) => state.role);

  const hasRoleOrAbove = (minimumRole: UserRoleType): boolean => {
    if (!role) return false;
    return ROLE_HIERARCHY[role] >= ROLE_HIERARCHY[minimumRole];
  };

  const hasExactRole = (exactRole: UserRoleType): boolean => {
    return role === exactRole;
  };

  const isSystemAdmin = role === UserRoleType.SYSTEM_ADMIN;

  return {
    hasRoleOrAbove,
    hasExactRole,
    isSystemAdmin,
  };
};
